import React, {useState, useEffect} from 'react';
import ListComponent from "./ListComponent";
import WindowLocation from "../Services/WindowLocation";
import Pagination from "../Design/Pagination";
import LoadMore from "../Design/LoadMore";
import DesignComponent from "../Design/DesignComponent";
import AttorneyList from "../Design/AttorneyList";
import Button from "../Design/Button";
import Input from "../Design/Input";

export default class Attorney extends ListComponent {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            isOpenFilter: false,
            isOpenFilterM: [],
            attorney: false,
            typingSearch: false,
        };

        this.refSearch = React.createRef();
        this.refFilter = React.createRef();
        this.refFilterDiv = React.createRef();
        this.refAttorney = React.createRef();

        this.orderName = null;

        this.openFilterObj = false;

        this.focusSearch = this.focusSearch.bind(this);
        this.blurSearch = this.blurSearch.bind(this);

        this.handleSearch = this.handleSearch.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleCheckbox = this.handleCheckbox.bind(this);

        this.openFilter = this.openFilter.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.clearLetter = this.clearLetter.bind(this);
        this.clearAll = this.clearAll.bind(this);

        this.selectAttorney = this.selectAttorney.bind(this);
        this.selectLetter = this.selectLetter.bind(this);

        this.startAutoScroll = this.startAutoScroll.bind(this);
        this.hasParams = this.hasParams.bind(this);

        this.currentAttorney = null;


    }

    componentDidMount() {
        if (!window.location.getHashObj) {
            WindowLocation.getWindowLocation();
        }

        if (this.config && this.config.params) {
            Object.values(this.config.params).map(param => {
                if (window.location.getHashObj(param.key)) {
                    if (param.render.type === 'checkbox' && typeof window.location.getHashObj(param.key) === 'string') {
                        window.location.addHash(param.key, [window.location.getHashObj(param.key)]);
                    }
                }

                if (param.key === 'order-name') {
                    const {
                        0: $keyValue,
                        1: $objValue
                    } = Object.entries(param.render.values).find(([k, v]) => v.value === param.default);
                    this.orderName = $objValue;
                }
            });
        }

        super.componentDidMount();

        document.addEventListener('componentDidMountIsLoaded', this.startAutoScroll);
    }

    startAutoScroll() {
        if (this.hasParams()) {
            this.scrollEvent(this.refAttorney);
        }
    }

    hasParams() {
        const {
            state: {params: $activeParams},
            config: {params: $params}
        } = this;
        let $scroll = ($activeParams['letter'] || $activeParams['s']);

        if ($params) {
            for (let $param of Object.values($params)) {
                if (['order-name'].indexOf($param.key) > -1 || !$param.render.values || Object.keys($param.render.values).length < 1) {
                    continue;
                }

                $scroll = $activeParams.hasOwnProperty($param.key) && $activeParams[$param.key];

                if ($scroll) {
                    break;
                }
            }
        }

        return $scroll;
    }

    focusSearch($event) {
        const $this = this;
        $this.setState({typingSearch: true});
    }

    blurSearch($event) {
        const $this = this;
        $this.setState({typingSearch: false});
    }

    handleSearch($event) {
        const {currentTarget: {value: search}, nativeEvent} = $event;
        if (nativeEvent.type === 'submit') {
            $event.preventDefault();
            return;
        }

        if (this.querySearchTimeOut) {
            clearTimeout(this.querySearchTimeOut);
        }

        this.focusSearch();

        this.querySearchTimeOut = setTimeout(() => {
            if (search) {
                window.location.addHash('s', search);
            } else {
                window.location.removeHash('s');
            }

            if (search && search.length > 2) {
                this.updateParams('s', search, () => {
                    this.getList();
                    this.blurSearch();
                    this.refSearch.current.blur();
                });
                WindowLocation.rewriteUrl();
            }
        }, 1000);
    }

    handleButton(param) {
        const {key, default: defaultValue, render: {values}} = param;
        const {state: {params: {[key]: value}}} = this;
        let $value = value;

        if (!$value) {
            $value = defaultValue;
        }

        const {0: $keyValue, 1: $objValue} = Object.entries(values).find(([k, v]) => v.value === $value);
        const next$Value = parseInt($keyValue) < Object.values(values).length - 1 ? parseInt($keyValue) + 1 : 0;
        this.orderName = values[next$Value];

        this.updateParams(key, this.orderName.value);

        if (this.orderName.value) {
            window.location.addHash(key, this.orderName.value);
        } else {
            window.location.removeHash(key);
        }

        WindowLocation.rewriteUrl();
    }

    handleCheckbox(key, value) {
        const {state: {params}} = this;
        let sections = params[key] ?? null;

        if (!sections) {
            sections = [value.value];
        } else {
            let checked = sections.indexOf(value.value);

            if (checked > -1) {
                sections = sections.filter((section, index) => index !== checked);
            } else {
                if (typeof sections === "string") {
                    sections = [sections];
                }

                sections = [...sections, value.value];
            }
        }

        this.updateParams(key, (sections && sections.length > 0) ? sections : null);

        if (sections !== null && sections.length > 0) {
            window.location.addHash(key, sections);
        } else {
            window.location.removeHash(key);
        }

        WindowLocation.rewriteUrl();
    }

    openFilter($openFilterObj = false) {
        let isOpenFilter = !this.state.isOpenFilter;

        if ($openFilterObj && (this.openFilterObj && this.openFilterObj !== $openFilterObj)) {
            isOpenFilter = true;
        }

        this.openFilterObj = $openFilterObj;

        for (let key in this.state.isOpenFilterM) {
            this.state.isOpenFilterM[key] = false;
        }
        if ($openFilterObj.id) {
            if (isOpenFilter) {
                // this.state.isOpenFilterM.forEach((key, index) => {
                //     this.state.isOpenFilterM[key] = false;
                // });
                this.state.isOpenFilterM[$openFilterObj.id] = true;
            }
        }


        this.setState({
            isOpenFilter: isOpenFilter
        }, () => {
            if (this.state.isOpenFilter) {
                this.toggleElement(this.refFilter)
                this.scrollEvent(this.refFilter)
            }
        });

    }

    clearSearch() {
        window.location.removeHash('s');

        this.updateParams('s', null);
        if (this.refSearch && this.refSearch.current) {
            this.refSearch.current.value = '';
        }

        WindowLocation.rewriteUrl();
    }

    clearLetter() {
        window.location.removeHash('letter');

        this.updateParams('letter', null);

        WindowLocation.rewriteUrl();
    }

    clearAll() {
        this.resetParams(() => {
            if (this.refSearch && this.refSearch.current) {
                this.refSearch.current.value = '';
            }

            this.clearSearch()
            this.openFilter(false);
        });
    }

    selectAttorney($attorney) {

        if (this.currentAttorney && this.currentAttorney.id == $attorney.id) {
            $attorney = null;
        }
        this.currentAttorney = $attorney;
        this.setState({
            attorney: $attorney
        }, () => {
            this.toggleElement(this.refAttorney)
            this.scrollEvent(this.refAttorney)
        });
    }

    selectLetter($letter, $event = null) {
        const $this = this;
        if ($event) {
            $event.preventDefault();
        }

        $letter = $letter.toLowerCase();

        this.updateParams($this.config.params.letter.key, $letter);
        window.location.addHash($this.config.params.letter.key, $letter);
        WindowLocation.rewriteUrl();

    }

    getList() {
        super.getList();
        this.selectAttorney(false);

    }

    render() {
        const $this = this;

        const {
            focusSearch: $focusSearch,
            blurSearch: $blurSearch,
            handleSearch: $handleSearch,
            handleCheckbox: $handleCheckbox,
            handleButton: $handleButton,
            openFilter: $openFilter,
            clearSearch: $clearSearch,
            clearLetter: $clearLetter,
            clearAll: $clearAll,
            selectAttorney: $selectAttorney,
            selectLetter: $selectLetter,
            refSearch: $refSearch,
            refAutoScroll: $refAutoScroll,
            refFilter: $refFilter,
            refFilterDiv: $refFilterDiv,
            refAttorney: $refAttorney,
            refList: $refList,
            state: {
                attorney: $attorney,
                params: $activeParams,
                loaded: $loaded,
                list: $list,
                totalPages: $totalPages,
                isOpenFilter: $isOpenFilter,
                isOpenFilterM: $isOpenFilterM,
                typingSearch: $typingSearch
            },
            config: {
                alphabeticalFilter: $alphabeticalFilter,
                params: $params,
                pagination: $pagination,
                messageNotFound: $messageNotFound,
                html: $html
            },
            isPagination: $isPagination,
            isLoadMore: $isLoadMore,
            page: $page,
            orderName: $orderName,
            openFilterObj: $openFilterObj
        } = $this;

        return <DesignComponent>

            <form onSubmit={$handleSearch}>
                <div>
                    <label>
                        <input type="text" placeholder="Name or Keyword" onKeyUp={$handleSearch} ref={$refSearch}
                               onFocus={$focusSearch}
                               onBlur={$blurSearch}
                               defaultValue={$activeParams.s ?? undefined}/>
                        {($typingSearch) && <span></span>}
                    </label>
                    <button type="button"><span>Search</span></button>
                </div>
            </form>

            {$html && <div id="featured-attorneys" dangerouslySetInnerHTML={{__html: $html}}/>}

            <h3>Find the right attorney for you</h3>

            <DesignComponent ref={this.refAttorney}>
                {$attorney && <>

                    <section className="featured-bios-fp-block left totoggle" style={{display: 'none'}}>
                        <div className={'wrapper'}>

                            <div className="heading">
                                <h2>
                                    Get Connected with a <strong>Professional</strong>
                                </h2>
                            </div>

                            <div className="bios-card">
                                <div className="bio">

                                    <div className="details">
                                        <h2 dangerouslySetInnerHTML={{__html: $attorney.title}}/>

                                        {$attorney.jobTitlePreferred &&
                                            <p className={'job-title-preferred'}>
                                                {$attorney.jobTitlePreferred}
                                            </p>}

                                        {($attorney.firstname && $attorney.phoneNumber && $attorney.email) &&
                                            <p className={'contact-name'}>Contact {$attorney.firstname}</p>}

                                        {$attorney.phoneNumber &&
                                            <p className={'contact-phone'}>
                                                <a href={`tel:${$attorney.phoneNumber}`}>{$attorney.phoneNumber}</a>
                                            </p>}

                                        {$attorney.email &&
                                            <p className={'contact-email'}>
                                                <a href={`mailto://${$attorney.email}`}>{$attorney.email}</a>
                                            </p>}

                                        {$attorney.permalink &&
                                            <p>
                                                <a className="btn" href={$attorney.permalink}>
                                                    Read {$attorney.firstname}’s bio
                                                </a>
                                            </p>}
                                    </div>

                                    <div className={'img'} style={{backgroundImage: `url(${$attorney.image})`}}></div>

                                </div>
                            </div>

                        </div>
                    </section>
                </>}
            </DesignComponent>

            {$alphabeticalFilter && <div className={'alphabetic-search-by-last-name'}>
                <p className={'heading-4'}>SEARCH BY LAST NAME:</p>
                <ul className={'alphabetic-list'}>
                    {Object.entries($alphabeticalFilter).map(([$letter, $isUsed]) => <li>
                        {$isUsed ?
                            <a href={`#`} onClick={($event) => $selectLetter($letter, $event)}>{$letter}</a> : $letter}
                    </li>)}
                </ul>
            </div>}

            <div className="advanced-filter">
                <div className="wrapper">
                    {$params && Object.entries($params).map(([key, param]) => (param.render && param.render !== false && param.app && param.app === 'Button') ?
                        <Button name={param.key}
                                label={`${param.render.label && param.render.label} ${($orderName && $orderName.label) ? $orderName.label : ''}`}
                                className={`${param.key}-${$activeParams[param.key]}`}
                                onClick={() => {
                                    $handleButton(param);
                                }}/> : null)}

                    {$this.config.hasOwnProperty('advanceSearch') && Object.entries($this.config.advanceSearch).map(([$key, $as]) =>
                        <button className={`advanced-search  ${$isOpenFilterM[$as.id] ? 'active' : ''}`}
                                onClick={() => $openFilter($as)}
                                type="button">
                            <span>{$as.label ? $as.label : 'Advanced Search'}</span>
                        </button>)}

                    <div className="active-filters">
                        {$activeParams['letter'] && <div className={'item'}>
                            <button type={'button'} onClick={event => {
                                event.preventDefault();
                                $clearLetter()
                            }}>
                                <span className="screen-reader-text">remove</span>
                                {$activeParams['letter']}
                            </button>

                        </div>}
                        {$activeParams['s'] && <div className={'item'}>
                            <button type={'button'} onClick={event => {
                                event.preventDefault();
                                $clearSearch()
                            }}>
                                <span className="screen-reader-text">remove</span>
                                {$activeParams['s']}
                            </button>

                        </div>}
                        {$params && Object.values($params).map(param => param.render.values && param.render.values.map(p => ['order-name'].indexOf(param.key) < 0 && $activeParams[param.key] && $activeParams[param.key].indexOf(p.value) > -1 &&
                            <div className={'item'}>
                                <button type="button" onClick={event => {
                                    event.preventDefault();
                                    $handleCheckbox(param.key, p)
                                }}>
                                    <span dangerouslySetInnerHTML={{__html: p.label}}/>
                                </button>
                            </div>))}
                    </div>

                    <DesignComponent ref={$refFilter}>
                        {($isOpenFilter && $openFilterObj && $openFilterObj.filters) &&
                            <div className={`filters totoggle ${$isOpenFilter ? 'active' : ''}`}
                                 style={{display: 'none'}} ref={$refFilterDiv}>
                                <div className={'inner'} key={'filter-inner-data'}>

                                    {$openFilterObj.filters.map($filter => ($params[$filter] && $params[$filter].render && $params[$filter].render !== false && $params[$filter].app && $params[$filter].app === 'Input') ?
                                        <Input name={$params[$filter].key}
                                               options={$params[$filter].render.values}
                                               values={$activeParams[$params[$filter].key]}
                                               type={$params[$filter].render.type ?? 'checkbox'}
                                               onChange={(val) => $handleCheckbox($params[$filter].key, val, $params[$filter].render.type ?? 'checkbox')}/> : '')}

                                    <button className="close" type="button" onClick={() => $openFilter(false)}>
                                        <span>Close</span>
                                    </button>

                                    {(window.location.hashObj !== false) &&
                                        <button type={"button"} onClick={$clearAll} className={'clear'}>
                                            <span>Clear All</span>
                                        </button>}
                                </div>
                            </div>}
                    </DesignComponent>

                </div>
            </div>

            <AttorneyList selectAttorney={$selectAttorney} attorneys={$list}
                          activeAttorney={$attorney}
                          ref={$refList}
                          messageNotFound={$messageNotFound} className={`${$loaded ? '' : 'loading'}`}
                          dataKey={'fp-attorney'} key={'fp-attorney'}
            />

            {$loaded && $list && Object.values($list).length < 1 && <p>{$messageNotFound}</p>}

            {(!$loaded || (window.location.getHashObj && window.location.getHashObj('debug'))) &&
                <div className={"load-more-container dynamic-loading"}>
                    <div className={"fp-loading"}><span/><br/> Loading</div>
                </div>}

            {($isLoadMore && $loaded && $page < $totalPages) && <LoadMore onClick={this.loadMore}/>}

            {($isPagination && $totalPages > 0) &&
                <Pagination onClick={this.loadPagination} page={$page} totalPage={$totalPages} config={$pagination}/>}
        </DesignComponent>
    }
}
